import notification from 'mini-toastr'
import i18n from '@/i18n'

const success = (
    message,
    title = i18n.t('notification.success'),
    timeout,
    cb,
    config
) => notification.success(message, title, timeout, cb, config)

const info = (
    message,
    title = i18n.t('notification.info'),
    timeout,
    cb,
    config
) => notification.info(message, title, timeout, cb, config)

const warning = (
    message,
    title = i18n.t('notification.warning'),
    timeout,
    cb,
    config
) => notification.warn(message, title, timeout, cb, config)

const danger = (
    message = i18n.t('notification.somethingWentWrong'),
    title = i18n.t('notification.danger'),
    timeout,
    cb,
    config
) => notification.error(message, title, timeout, cb, config)

export default notification
export { success, warning, danger, info }
